import { inject } from '@angular/core';
import { marker } from '@eventlyte/common';
import {
	IRegistrationStepService,
	RegistrationStep,
	RegistrationStepType
} from '@eventlyte/registration';
import {
	faCircleCheck,
	faClipboardQuestion,
	faPeopleGroup,
	faUser
} from '@fortawesome/pro-solid-svg-icons';
import { TranslocoService } from '@jsverse/transloco';
import { AppRoutePaths } from '../app.routes';

export class RegistrationStepService implements IRegistrationStepService {
	private translocoService = inject(TranslocoService);

	public getSteps(): RegistrationStep[] {
		return [
			{
				label: this.translocoService.translate(marker('content.steps.personalInfo')),
				icon: faUser,
				route: AppRoutePaths.RegistrationInformation,
				type: RegistrationStepType.Default
			},
			{
				label: this.translocoService.translate(marker('content.steps.questions')),
				icon: faClipboardQuestion,
				route: AppRoutePaths.RegistrationQuestions,
				type: RegistrationStepType.Default
			},
			{
				label: this.translocoService.translate(marker('content.steps.matching')),
				icon: faClipboardQuestion,
				route: AppRoutePaths.RegistrationMatching,
				type: RegistrationStepType.Default
			},
			{
				label: this.translocoService.translate(marker('content.steps.group')),
				icon: faPeopleGroup,
				route: AppRoutePaths.RegistrationGroup,
				type: RegistrationStepType.Submit
			},
			{
				label: this.translocoService.translate(marker('content.steps.confirmation')),
				icon: faCircleCheck,
				route: AppRoutePaths.RegistrationConfirmation,
				type: RegistrationStepType.Confirmation
			}
		];
	}
}
